class objContractDelete {
    constructor(oyaseino, csncb1) {
      this.Oyaseino = oyaseino;
      this.Csncb1 = csncb1;
    }
  }
  
  export default objContractDelete;